import { ContactAlertSettingModalComponent } from './contact-alert-setting-modal.component';
import { CommonModule } from '@angular/common';
import { BlNgCommonModule } from '@blcloud/bl-ng-common';
import { BlNgUiComponentModule } from '@blcloud/bl-ng-ui-component';
import { CollapseModule } from 'ngx-bootstrap';
import { PostalCodeInputModule, EmployeeResourceService } from '@blcloud/bl-ng-share-module';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { ContactAlertSettingResource, ContactExecuteItemResource } from '@blcloud/bl-ng-resource';

@NgModule({
  imports: [
    CommonModule,
    BlNgCommonModule,
    BlNgUiComponentModule,
    CollapseModule,

    PostalCodeInputModule,
  ],
  exports: [
    ContactAlertSettingModalComponent
  ],
  declarations: [
    ContactAlertSettingModalComponent
  ],
  entryComponents: [
    ContactAlertSettingModalComponent
  ],
  providers: [
    ContactAlertSettingResource,
    EmployeeResourceService,
    ContactExecuteItemResource,
  ]
})
export class ContactAlertSettingModalModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: ContactAlertSettingModalModule,
      providers: [
        CollapseModule.forRoot().providers,
      ]
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/feature/contact-alert-setting/contact-alert-setting-modal.module.ts